import {useRef, useCallback} from 'react';

export const useDebouncedPromise = <Args extends any[] = any[], R = any>(
  callback: (...args: Args) => Promise<R>,
  wait = 10000
) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;

  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const pendingRef = useRef<Array<(value: R) => void>>([]);

  return useCallback(
    (...args: Args): Promise<R> =>
      new Promise(resolve => {
        pendingRef.current.push(resolve);

        if (timeoutRef.current) {
          clearTimeout(timeoutRef.current);
        }

        timeoutRef.current = setTimeout(async () => {
          const result = await callbackRef.current(...(args as Args));
          const resolves = pendingRef.current.splice(0);

          resolves.forEach(r => r(result));

          timeoutRef.current = null;
        }, wait);
      }),
    [wait]
  );
};
